module.exports = __webpack_public_path__ + "static/media/resolute-AI-logo-rectangle.1148f786.png";